// extracted by mini-css-extract-plugin
export default {"notetitle_wrap":"dropdownarrow_notetitle_wrap__pcvRq"};